module.exports = __webpack_public_path__ + "img/icon_grid_minus.bc1c874e.svg";